import Column from '@amzn/meridian/column';
import { TableActionBar } from '@amzn/meridian/table';
// biome-ignore lint/style/noRestrictedImports: legacy code
import { sift } from 'radash';
import type { FC } from 'react';

import { CreateJagButton } from '../CreateJagButton';
import { JagListViewSearch } from '../JagListViewSearch';

export const JagListViewActionBar: FC = () => (
  <TableActionBar
    alignmentHorizontal="start"
    data-cy="asin-list-view-action-bar"
    widths={sift([
      'grid-4',
      'fill',
      'fit',
    ])}
  >
    <JagListViewSearch />
    <Column />
    <CreateJagButton />
  </TableActionBar>
);
